export default [
	{ id: 'ONE', question: 'Drives for Conditions' },
	{ id: 'TWO', question: '50 ft 8 ft Stops' },
	{ id: 'THREE', question: ' Traffic Pattern Behavior' },
	{ id: 'FOUR', question: 'Ground Guided Approaches' },
	{ id: 'FIVE', question: 'Verified Dolly Pins' },
	{ id: 'SIX', question: '3 points of Contact' }
]
